/**
 * CMCD request header name.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_REQUEST = 'CMCD-Request';
